import React from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import InfoIcon from '@material-ui/icons/Info';
import './financial-advisory.scss';
import { makeStyles, Theme } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';
import ResponseTooltip from '../tooltips/ResponseTooltip';

const useStyles = makeStyles((theme: Theme) => ({
	customCard: {
		minWidth: 440,
		backgroundColor: 'white',
		opacity: 1,
		zIndex: 1,
		borderRadius: 8,
	},
	tooltip: {
		maxWidth: 160,
		color: 'white',
		backgroundColor: '#004E9C',
		marginTop: 16,
	},
	arrow: {
		color: '#004E9C',
	},
	divider: {
		width: '100%',
		marginTop: 16,
	},
	requisitosIcon: {
		color: '#4EB2EB',
	},
}));

type ResponseAdvisoryProps = {
	salary: string;
	totalFinancial: number;
};

function ResponseAdvisory({ salary, totalFinancial }: ResponseAdvisoryProps) {
	const classes = useStyles();
	const referencial = totalFinancial / 0.8;
	return (
		<div className="response-box">
			<h1 className="response-title">
				Con un sueldo líquido de &nbsp;
				<NumberFormat
					prefix={'$'}
					value={salary}
					displayType={'text'}
					thousandSeparator={'.'}
					decimalSeparator={'n'}
					isNumericString
				/>
			</h1>

			<div className="response-card">
				<div className="response-card-header">
					<div className="response-card-valor">
						<p>Te podemos prestar hasta:</p>
						<div className="response-total-valor">
							<NumberFormat
								prefix={'$'}
								value={totalFinancial}
								displayType={'text'}
								thousandSeparator={'.'}
								decimalSeparator={'ñ'}
								isNumericString
							/>
							<ResponseTooltip title="Este es el monto máximo que te podríamos prestar y equivale entre el 40% y el 80% del valor del vehículo a financiar. " />
						</div>
					</div>
					<p className="response-card-valor-referencial">
						Valor referencial del vehículo:&nbsp;
						<span>
							<NumberFormat
								prefix={'$'}
								value={referencial}
								displayType={'text'}
								thousandSeparator={'.'}
								decimalSeparator={'n'}
								isNumericString
							/>
						</span>
					</p>
				</div>
				<hr className={classes.divider}></hr>

				<div className="respose-card-requisitos">
					<p className="titulo-requisitos"> Requisitos:</p>
					<div className="item-requisito">
						<CheckCircleOutlineIcon className={classes.requisitosIcon} />
						<p>
							{' '}
							Pie mínimo requerido: <strong>20%</strong>
						</p>
					</div>
					<div className="item-requisito">
						<CheckCircleOutlineIcon className={classes.requisitosIcon} />
						<p> Mínimo 1 año de antigüedad laboral</p>
					</div>
					<div className="item-requisito">
						<CheckCircleOutlineIcon className={classes.requisitosIcon} />
						<p> No presentar atrasos ni morosidades</p>
					</div>
				</div>
				<hr className={classes.divider}></hr>

				<div className="response-card-bajada">
					<InfoIcon className="info-icon" />
					<p>
						El monto simulado <strong>no implica una pre-aprobación</strong> y queda sujeto a
						evaluación de riesgo.
					</p>
				</div>
			</div>

			<div className="bajada">
				Recuerda que el valor de tu vehículo lo decides tú y mientras mayor sea el porcentaje del
				pie , menor será la cuota a pagar.
			</div>
		</div>
	);
}

export default ResponseAdvisory;
